export const GlobalFunctions = {
    validaForm(form: any, campos: string[], validacoes: any[]) : (boolean) {
        let campoInvalido: string = "";
        for (let i = 0; i < campos.length; i++) {
            let campo = campos[i];
            validacoes.forEach(val => {
                if (form[campo] == val) {
                    campoInvalido = campo;
                }
            });
        }

        if (campoInvalido != "") {
            alert("Preencha corretamente os campos para salvar! " + campoInvalido);
        }
        
        return campoInvalido == "";
    },

    // Método para codificar um objeto em base64
    encode(data: any): string {
        const jsonString = JSON.stringify(data);
        return btoa(unescape(encodeURIComponent(jsonString)));
    },

    // Método para decodificar um string base64 para um objeto
    decode(data: string): any {
        const jsonString = decodeURIComponent(escape(atob(data)));
        return JSON.parse(jsonString);
    },
}

export const environment = {
    production: false,
    api_endpoint: "/api", // "http://localhost:3000/api",
    currentUser: localStorage.getItem("attlxe221") ? GlobalFunctions.decode(localStorage.getItem("attlxe221") || "") : null,
    titleProject: "Logic World",
    defaultImageError: "https://static.vecteezy.com/system/resources/previews/005/337/799/non_2x/icon-image-not-found-free-vector.jpg",
    translations: <any>{},
    secretKey: "4f3c9d8a7b6e5d4c3b2a1f0e9d8c7b6a5e4d3c2b1a0f9e8d7c6b5a4e3d2c1b0"
};
